







import { Component, Vue } from 'vue-property-decorator'
import NotificationSettings from '@/components/notification/NotificationSettings.vue'

@Component({
  components: {
    NotificationSettings,
  },
})
export default class NotificationSettingsPage extends Vue {}
